var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "120",
      height: "150",
      label: "服务器信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v(_vm._s(_vm.serverList[scope.row.serverId]))]), scope.row.serverIdMerge != 0 ? _c("p", [_vm._v(" 合服后： " + _vm._s(_vm.serverList[scope.row.serverIdMerge]) + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "300",
      height: "150",
      label: "角色信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("a", {
          staticStyle: {
            cursor: "pointer",
            color: "#409EFF"
          },
          on: {
            click: function click($event) {
              return _vm.goRouterMsg(scope.row.roleId);
            }
          }
        }, [_vm._v("角色id：" + _vm._s(scope.row.roleId))]), _c("p", [_vm._v("角色名称：" + _vm._s(scope.row.roleName))]), _c("p", [_vm._v("角色等级：" + _vm._s(scope.row.roleLevel))]), _c("p", [_vm._v("VIP等级: " + _vm._s(scope.row.roleVipLevel))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "250",
      height: "150",
      label: "登录信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("创角时间：" + _vm._s(scope.row.createRoleTime))]), _c("p", [_vm._v("进入游戏：" + _vm._s(scope.row.logTime))]), _c("p", [_vm._v("场景值：" + _vm._s(scope.row.scene))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "250",
      height: "150",
      label: "离线信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.quitTime == scope.row.logTime ? _c("p", [_vm._v("断线重连")]) : scope.row.quitTime == "1970-01-01 00:00:00" ? _c("p", [_vm._v("未离线")]) : _c("p", [_vm._v("离线时间：" + _vm._s(scope.row.quitTime))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "IP"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("a", {
          staticStyle: {
            color: "#409EFF"
          },
          attrs: {
            target: "_black",
            href: "http://ip.tool.chinaz.com/" + scope.row.ip
          }
        }, [_vm._v(_vm._s(scope.row.ip))])];
      }
    }])
  })], 1)], _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };